import gsap from 'gsap';
import { SECTIONS_IDS } from 'constants/global';

export const experienceAnimation = () => {
  let headlightsPlayed = false;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `#${SECTIONS_IDS.experience}`,
      start: '-=25 top',
      end: '+=1500',
      scrub: true,
      pin: true,
      pinSpacing: 'padding',
      invalidateOnRefresh: true,
      onLeaveBack: () => {
        headlightsPlayed = false;
      },
      onUpdate: self => {
        if (self.progress >= 0.71 && !headlightsPlayed) {
          headlightsPlayed = true;
          gsap
            .timeline()
            .to('#experience-bg-headlights', { opacity: 1, duration: 0.15 })
            .to('#experience-bg-headlights', { opacity: 0, duration: 0.15 })
            .to('#experience-bg-headlights', { opacity: 1, duration: 0.15 })
            .to('#experience-bg-headlights', { opacity: 0, duration: 0.15 })
            .to('#experience-bg-headlights', { opacity: 1, duration: 0.15 })
            .to('#experience-bg-headlights', { opacity: 0, duration: 0.15 });
        }
      },
    },
  });

  tl.to('#experience-title', { yPercent: -20, opacity: 0 });
  tl.fromTo('#experience-second-title', { yPercent: 20, opacity: 0 }, { yPercent: 0, opacity: 1 });
  tl.to('#experience-second-title', { yPercent: -7, opacity: 0 });
  tl.fromTo('#experience-text', { yPercent: 20, opacity: 0 }, { yPercent: 0, opacity: 1 });
  tl.to('#experience-text', { yPercent: -7, opacity: 0 });
  tl.to({}, { duration: 1 });
};
